(function () {
  console.log("Loaded contact freshdesk form js");

  const ContactFormItemNameMappings = {
    "contact[First Name]": "firstName",
    "contact[Last Name]": "lastName",
    "contact[email]": "email",
    "contact[Gender]": "gender",
    "contact[Age]": "birthYear",
    "contact[Housing Type]": "home",
    "contact[Living Status]": "living",
    "contact[How did you hear about Mopio?]": "mopioSource",
    "contact[Yes, I'd like to enter the Monthly Giveaway. I've read and consent to the Giveaway's Terms & Conditions.]":
      "giveaway",
    "contact[Marketplace]": "marketplace",
    "contact[Order ID]": "orderId",
  };

  var data = {};
  var form;
  var isLoading = false;

  function startLoading() {
    isLoading = true;
  }

  function stopLoading() {
    isLoading = false;
  }

  var initMarketplaceSelect = function () {
    form
      .find(`select[name="contact[Marketplace]"] > option`)
      .click(function () {
        var optionValue = $(this).text().trim();

        switch (optionValue) {
          case "Amazon":
            form
              .find('input[name="contact[Order ID]"]')
              .attr("placeholder", "e.g. 112-0300099-8000615");
            break;
          case "Mopio.com":
            form
              .find('input[name="contact[Order ID]"]')
              .attr("placeholder", "e.g. SF-1234");
            break;
          default:
            form
              .find('input[name="contact[Order ID]"]')
              .attr("placeholder", "Order ID");
        }

        form.find("#select_marketplace .default_option span").text(optionValue);
      });
  };

  function formatDescriptionByData(data) {
    var arr = [];
    var keys = Object.keys(data);
    for (var i in keys) {
      var key = keys[i];
      if (key) {
        var keyName = key.slice(0, 1).toUpperCase() + key.slice(1);
        arr.push(keyName + " : <br/>" + data[key]);
      }
    }
    return arr.sort().join("<br/><br/>");
  }

  function getSubmitValues(formValues) {
    var data = {};
    // console.log(form.serializeArray());
    Array.prototype.forEach.call(formValues, function (v) {
      if (v.type === "hidden" || v.type === "submit") {
        return;
      }
      if (v.type === "checkbox") {
        data[ContactFormItemNameMappings[v.name]] = v.checked;
        return;
      }
      data[ContactFormItemNameMappings[v.name]] = v.value;
      return;
    });
    return data;
  }

  var beforeSend = function (xhr) {
    xhr.setRequestHeader(
      "Authorization",
      "Basic " + btoa("1VxUnq2Kl5NiCGQpxv6:X")
    );
  };

  var showThankyou = function () {
    window.location.href =
      "https://mopio.com/pages/contact-page-new?contact_posted=true";
  };

  var bindSubmit = function () {
    form.submit(function (event) {
      event.preventDefault();

      if (isLoading) {
        return;
      }

      data = getSubmitValues(event.target);

      startLoading();

      $.ajax({
        url: "https://mopio.freshdesk.com/api/v2/tickets",
        type: "post",
        contentType: "application/json",
        dataType: "json",
        async: false,
        data: JSON.stringify({
          subject: data.marketplace
            ? "Warranty Registration"
            : "Club Registration",
          description: formatDescriptionByData(data),
          email: data.email,
          status: 2,
          priority: 1,
          group_id: 48000617191,
          type: "General Enquiry",
          
          custom_fields: {
            cf_issue_type: "General",
            cf_sub_issue_type: data.marketplace
              ? "Warranty Registration"
              : "Club Registration",
            cf_last_name: data.firstName,
            cf_phone_number: data.phone,
            cf_buyer_email: data.email,
            cf_gender: data.gender,
            cf_birth_year: data.birthYear,
            cf_home_type: data.home,
            cf_living_status: data.living,
            cf_mopio_source: data.mopioSource,
            cf_giveaway: data.giveaway,
            cf_channel: data.marketplace,
            cf_order_id: data.orderId,
          },
        }),
        success: function (result) {
          stopLoading();
          showThankyou();
        },
        error: function (error) {
          stopLoading();
        },
        beforeSend: beforeSend,
      });
    });
  };

  window.onload = function () {
    const $ = jQuery;
    form = $(".contact-form__form");

    // initMopioSourceSelect();
    // initExistingCheckout();
    // initGenderSelect();
    // initBirthYearSelect();
    // initPhoneNumberSelect();
    // initHomeTypeSelect();
    // initLivingStatusSelect();
    initMarketplaceSelect();

    bindSubmit();
  };
})();
